var exports = {
  "Qs": "DebugModal.module__content___N3dmNl",
  "kL": "DebugModal.module__container___N3dmNl",
  "sN": "DebugModal.module__tabsSection___N3dmNl",
  "vR": "DebugModal.module__tabs___N3dmNl",
  "P1": "DebugModal.module__scrollArea___N3dmNl",
  "z": "DebugModal.module__summary___N3dmNl",
  "hZ": "DebugModal.module__summaryTitle___N3dmNl",
  "D_": "DebugModal.module__summaryBody___N3dmNl",
  "Ip": "DebugModal.module__summaryItem___N3dmNl",
  "rG": "DebugModal.module__summaryLabel___N3dmNl",
  "Qb": "DebugModal.module__summaryValue___N3dmNl",
  "ZP": "DebugModal.module__codeSection___N3dmNl",
  "Dy": "DebugModal.module__codeSurface___N3dmNl",
};

module.exports = exports;
